module.exports = __webpack_public_path__ + "img/dedicated_dial_in_number.0d92e4e3.svg";